import React from 'react';

function Lebanon(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124076)">
        <mask
          id="mask0_800_124076"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124076)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M36 0H0V6H36V0ZM36 18H0V24H36V18Z"
            fill="#F50101"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 6H36V18H0V6Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.2043 12.5132C24.2882 13.3806 20.6872 12.1534 20.6872 12.5006C20.6872 12.8479 24.5447 13.4577 24.5383 14.2351C24.5318 15.0125 19.9643 14.0133 20.9886 14.3629C22.0128 14.7125 24.212 15.5494 23.962 16.0708C23.4282 17.1843 19.8827 15.2983 19.5878 15.6701C19.1119 16.2699 22.2042 17.6688 22.178 17.8025C22.1276 18.0588 20.066 17.3996 19.5878 17.9319C19.2007 17.8348 19.0217 17.3714 18.9015 17.3099L18.1406 8.58658C18.1406 8.58658 18.8238 16.8 17.9509 17.0362C17.078 17.2724 14.6531 17.9906 14.5825 17.6319C14.5563 17.4983 17.5022 16.2699 17.0263 15.6701C16.6758 15.2282 13.1206 16.7955 12.8938 15.8879C11.8834 15.2405 16.1661 14.6802 16.1661 14.0181C16.1661 13.3559 12.2482 14.8018 12.7169 13.88C13.1856 12.9583 16.3222 12.6283 16.3807 12.5006C16.4877 12.2672 12.8938 12.8641 12.8938 12.5006C12.8938 11.8129 15.045 11.6776 16.3807 11.0588C16.4597 10.3525 13.1404 11.754 12.8938 11.1879C12.6472 10.6218 17.1363 9.15513 17.0263 9.04088C16.8526 8.86044 13.2347 9.67461 13.8314 9.24706C14.9893 8.41726 17.2496 7.28888 17.7697 6.98789C17.7697 6.98789 17.8323 6.87433 17.8993 6.91287C17.9664 6.87433 18.0401 6.83212 18.0401 6.83212C18.0401 6.83212 18.0401 7.54215 18.029 6.98789C18.0179 6.43364 23.3273 8.8589 23.3876 9.4737C23.4578 10.1919 20.107 8.93224 20.1858 9.63845C20.8669 10.0136 22.8043 10.7395 23.6047 11.0588C23.9678 11.2035 20.9297 10.7523 20.9939 10.9738C21.1574 11.5385 24.1168 11.6086 24.2043 12.5132Z"
            fill="#52AB0B"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124076">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Lebanon;
